// assets
import {
  AntDesignOutlined,
  AppstoreAddOutlined,
  ApartmentOutlined,
  BarcodeOutlined,
  BarChartOutlined,
  BellOutlined,
  BgColorsOutlined,
  ChromeOutlined,
  DashboardOutlined,
  FileTextOutlined,
  LoadingOutlined,
  ProfileOutlined,
  QuestionOutlined
} from '@ant-design/icons';

// icons
const icons = {
  AntDesignOutlined,
  AppstoreAddOutlined,
  ApartmentOutlined,
  BarcodeOutlined,
  BarChartOutlined,
  BellOutlined,
  BgColorsOutlined,
  ChromeOutlined,
  DashboardOutlined,
  FileTextOutlined,
  LoadingOutlined,
  ProfileOutlined,
  QuestionOutlined
};

// ==============================|| MENU ITEMS - AEGIS WEBSHIELD AI ||============================== //

const aegis = [
  {
    id: 'group-overview',
    type: 'group',
    children: [
      {
        id: 'security-dashboard',
        title: '보안 현황',
        type: 'item',
        url: '/dashboard/security',
        icon: icons.DashboardOutlined,
        breadcrumbs: false
      },
      {
        id: 'onboarding',
        title: '초기 설정',
        type: 'item',
        url: '/onboarding',
        icon: icons.AppstoreAddOutlined
      }
    ]
  },
  {
    id: 'group-projects',
    title: '프로젝트',
    type: 'group',
    children: [
      {
        id: 'project-list',
        title: '프로젝트 목록',
        type: 'item',
        url: '/projects',
        icon: icons.AppstoreAddOutlined
      },
      {
        id: 'target-url-api',
        title: '대상 URL/API',
        type: 'item',
        url: '/projects/targets',
        icon: icons.ChromeOutlined
      },
      {
        id: 'project-members',
        title: '팀/권한',
        type: 'item',
        url: '/projects/members',
        icon: icons.ProfileOutlined
      }
    ]
  },
  {
    id: 'group-scans',
    title: '스캔 관리',
    type: 'group',
    children: [
      {
        id: 'new-scan',
        title: '새 스캔 실행',
        type: 'item',
        url: '/scans/new',
        icon: icons.LoadingOutlined
      },
      {
        id: 'running-scans',
        title: '진행 중 스캔',
        type: 'item',
        url: '/scans/running',
        icon: icons.BarChartOutlined
      },
      {
        id: 'scan-history',
        title: '스캔 이력',
        type: 'item',
        url: '/scans/history',
        icon: icons.BarcodeOutlined
      },
      {
        id: 'recheck',
        title: '재검증',
        type: 'item',
        url: '/scans/recheck',
        icon: icons.QuestionOutlined
      },
      {
        id: 'scan-quality-learning',
        title: '스캔 품질 학습',
        type: 'item',
        url: '/scans/quality-learning',
        icon: icons.AntDesignOutlined
      }
    ]
  },
  {
    id: 'group-findings',
    title: '취약점 관리',
    type: 'group',
    children: [
      {
        id: 'finding-list',
        title: '취약점 목록',
        type: 'item',
        url: '/findings',
        icon: icons.BarcodeOutlined
      },
      {
        id: 'finding-exceptions',
        title: '오탐/예외 승인',
        type: 'item',
        url: '/findings/exceptions',
        icon: icons.QuestionOutlined
      },
      {
        id: 'finding-priorities',
        title: '위험도 우선순위',
        type: 'item',
        url: '/findings/priorities',
        icon: icons.BarChartOutlined
      }
    ]
  },
  {
    id: 'group-ai',
    title: 'AI 분석',
    type: 'group',
    children: [
      {
        id: 'ai-analysis-result',
        title: 'AI 분석 결과',
        type: 'item',
        url: '/ai/analysis',
        icon: icons.AntDesignOutlined
      },
      {
        id: 'fix-guide',
        title: 'Fix Guide',
        type: 'item',
        url: '/ai/fix-guide',
        icon: icons.BgColorsOutlined
      },
      {
        id: 'knowledge-search',
        title: '공개 보안 지식 검색',
        type: 'item',
        url: '/ai/knowledge-search',
        icon: icons.ChromeOutlined
      }
    ]
  },
  {
    id: 'group-reports',
    title: '리포트',
    type: 'group',
    children: [
      {
        id: 'report-list',
        title: '리포트 목록',
        type: 'item',
        url: '/reports',
        icon: icons.ProfileOutlined
      },
      {
        id: 'customer-report',
        title: '고객 제출용 리포트',
        type: 'item',
        url: '/reports/customer',
        icon: icons.BarChartOutlined
      },
      {
        id: 'recheck-report',
        title: '재검증 리포트',
        type: 'item',
        url: '/reports/recheck',
        icon: icons.QuestionOutlined
      }
    ]
  },
  {
    id: 'group-cicd',
    title: 'CI/CD Gate',
    type: 'group',
    children: [
      {
        id: 'github-actions',
        title: 'GitHub Actions 연동',
        type: 'item',
        url: '/cicd/github-actions',
        icon: icons.ChromeOutlined
      },
      {
        id: 'gate-policies',
        title: '배포 차단 정책',
        type: 'item',
        url: '/cicd/policies',
        icon: icons.BarcodeOutlined
      },
      {
        id: 'api-tokens',
        title: 'API Token',
        type: 'item',
        url: '/cicd/tokens',
        icon: icons.QuestionOutlined
      }
    ]
  },
  {
    id: 'group-platform-admin',
    title: 'Platform Admin',
    type: 'group',
    access: 'platform_admin',
    children: [
      {
        id: 'platform-overview',
        title: '운영 대시보드',
        type: 'item',
        url: '/platform/overview',
        icon: icons.DashboardOutlined,
        access: 'platform_admin'
      },
      {
        id: 'platform-organizations',
        title: '조직/플랜 조회',
        type: 'item',
        url: '/platform/organizations',
        icon: icons.ApartmentOutlined,
        access: 'platform_admin'
      },
      {
        id: 'platform-scans',
        title: '스캔 운영',
        type: 'item',
        url: '/platform/scans',
        icon: icons.LoadingOutlined,
        access: 'platform_admin'
      },
      {
        id: 'platform-users',
        title: '유저 관리',
        type: 'item',
        url: '/platform/users',
        icon: icons.ProfileOutlined,
        access: 'platform_admin'
      },
      {
        id: 'platform-plan-change-requests',
        title: '플랜 변경 요청',
        type: 'item',
        url: '/platform/plan-change-requests',
        icon: icons.BarChartOutlined,
        access: 'platform_admin'
      },
      {
        id: 'platform-billing',
        title: '매출/청구',
        type: 'item',
        url: '/platform/billing',
        icon: icons.BarChartOutlined,
        access: 'platform_admin'
      },
      {
        id: 'platform-support-notes',
        title: '지원 메모',
        type: 'item',
        url: '/platform/support-notes',
        icon: icons.FileTextOutlined,
        access: 'platform_admin'
      },
      {
        id: 'platform-support-tickets',
        title: '고객문의',
        type: 'item',
        url: '/platform/support-tickets',
        icon: icons.QuestionOutlined,
        access: 'platform_admin'
      },
      {
        id: 'platform-support-readiness',
        title: '지원 운영',
        type: 'item',
        url: '/platform/support-readiness',
        icon: icons.QuestionOutlined,
        access: 'platform_admin'
      },
      {
        id: 'platform-notifications',
        title: '알림 이력',
        type: 'item',
        url: '/platform/notifications',
        icon: icons.BellOutlined,
        access: 'platform_admin'
      }
    ]
  },
  {
    id: 'group-settings',
    title: '설정',
    type: 'group',
    children: [
      {
        id: 'account-settings',
        title: '계정 설정',
        type: 'item',
        url: '/settings/account',
        icon: icons.ProfileOutlined
      },
      {
        id: 'organization-settings',
        title: '조직 설정',
        type: 'item',
        url: '/settings/organization',
        icon: icons.AppstoreAddOutlined
      },
      {
        id: 'billing',
        title: '요금제/사용량',
        type: 'item',
        url: '/settings/billing',
        icon: icons.BarChartOutlined
      },
      {
        id: 'audit-logs',
        title: '감사 로그',
        type: 'item',
        url: '/settings/audit-logs',
        icon: icons.BarcodeOutlined
      }
    ]
  }
];

export default aegis;
